import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.059 1L20.9614 20.2076L12.0002 23.568L3.03898 20.2076L1.94141 1H22.059ZM7.78747 7H16.4952L18.215 7.01719L18.3304 5H5.66992L6.09145 12.3768L15.9055 12.3768L15.6959 16.0461L12.0002 17.432L8.30439 16.0461L8.25566 15.1933L8.2117 14.0734H6.1884L6.38199 17.4612L12.0002 19.568L17.6183 17.4612L18.0231 10.3768L7.98043 10.3768L7.78747 7Z"}}]};

const Html5Filled = Vue.extend<IconProps>({
  name: 'Html5FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'html5-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Html5Filled;
